import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, LinkedinIcon, PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export const Footer = () => {
  return <footer className="bg-[#3a4a56] text-white w-full" data-id="element-372">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-373">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-374">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-375">
            <h3 className="text-xl font-normal mb-6 logo-text" data-id="element-376">Immovendu</h3>
            <p className="text-gray-300" data-id="element-377">
              Find your dream home today with our{' '}
              <span className="font-medium" data-id="element-378">expert real estate services</span>{' '}
              for luxury listings.
            </p>
            <div className="flex space-x-4 mt-6" data-id="element-379">
              <motion.a href="#" className="text-gray-300 hover:text-[#f2f2ed]" whileHover={{
              scale: 1.2,
              color: '#f2f2ed'
            }} transition={{
              type: 'spring',
              stiffness: 400
            }} data-id="element-380">
                <FacebookIcon className="h-5 w-5" data-id="element-381" />
              </motion.a>
              <motion.a href="#" className="text-gray-300 hover:text-[#f2f2ed]" whileHover={{
              scale: 1.2,
              color: '#f2f2ed'
            }} transition={{
              type: 'spring',
              stiffness: 400
            }} data-id="element-382">
                <InstagramIcon className="h-5 w-5" data-id="element-383" />
              </motion.a>
              <motion.a href="#" className="text-gray-300 hover:text-[#f2f2ed]" whileHover={{
              scale: 1.2,
              color: '#f2f2ed'
            }} transition={{
              type: 'spring',
              stiffness: 400
            }} data-id="element-384">
                <TwitterIcon className="h-5 w-5" data-id="element-385" />
              </motion.a>
              <motion.a href="#" className="text-gray-300 hover:text-[#f2f2ed]" whileHover={{
              scale: 1.2,
              color: '#f2f2ed'
            }} transition={{
              type: 'spring',
              stiffness: 400
            }} data-id="element-386">
                <LinkedinIcon className="h-5 w-5" data-id="element-387" />
              </motion.a>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-388">
            <h3 className="text-lg font-normal mb-6" data-id="element-389">Quick Links</h3>
            <ul className="space-y-3" data-id="element-390">
              <motion.li whileHover={{
              x: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-391">
                <Link to="/" className="text-gray-300 hover:text-[#f2f2ed]" data-id="element-392">
                  Home
                </Link>
              </motion.li>
              <motion.li whileHover={{
              x: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-393">
                <Link to="/about" className="text-gray-300 hover:text-[#f2f2ed]" data-id="element-394">
                  About Us
                </Link>
              </motion.li>
              <motion.li whileHover={{
              x: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-395">
                <Link to="/" className="text-gray-300 hover:text-[#f2f2ed]" data-id="element-396">
                  Properties
                </Link>
              </motion.li>
              <motion.li whileHover={{
              x: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-397">
                <Link to="/" className="text-gray-300 hover:text-[#f2f2ed]" data-id="element-398">
                  Appointments
                </Link>
              </motion.li>
              <motion.li whileHover={{
              x: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-399">
                <Link to="/contact" className="text-gray-300 hover:text-[#f2f2ed]" data-id="element-400">
                  Contact
                </Link>
              </motion.li>
            </ul>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-401">
            <h3 className="text-lg font-normal mb-6" data-id="element-402">Properties</h3>
            <ul className="space-y-3" data-id="element-403">
              <motion.li whileHover={{
              x: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-404">
                <a href="#" className="text-gray-300 hover:text-[#f2f2ed]" data-id="element-405">
                  Luxury Homes
                </a>
              </motion.li>
              <motion.li whileHover={{
              x: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-406">
                <a href="#" className="text-gray-300 hover:text-[#f2f2ed]" data-id="element-407">
                  Waterfront Properties
                </a>
              </motion.li>
              <motion.li whileHover={{
              x: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-408">
                <a href="#" className="text-gray-300 hover:text-[#f2f2ed]" data-id="element-409">
                  Penthouses
                </a>
              </motion.li>
              <motion.li whileHover={{
              x: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-410">
                <a href="#" className="text-gray-300 hover:text-[#f2f2ed]" data-id="element-411">
                  Condominiums
                </a>
              </motion.li>
              <motion.li whileHover={{
              x: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-412">
                <a href="#" className="text-gray-300 hover:text-[#f2f2ed]" data-id="element-413">
                  New Developments
                </a>
              </motion.li>
            </ul>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-414">
            <h3 className="text-lg font-normal mb-6" data-id="element-415">Contact</h3>
            <ul className="space-y-3 text-gray-300" data-id="element-416">
              <motion.li className="flex items-center" whileHover={{
              x: 3
            }} data-id="element-417">
                <MapPinIcon className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-418" />
                <span data-id="element-419">Royal LePage du Quartier</span>
              </motion.li>
              <motion.li className="pl-6" data-id="element-420">
                6971 Ch. Côte-de-Liesse, #C
              </motion.li>
              <motion.li className="pl-6" data-id="element-421">
                Montréal (St-Laurent), QC H4T 1Z3
              </motion.li>
              <motion.li className="flex items-center mt-2" whileHover={{
              x: 3
            }} data-id="element-422">
                <PhoneIcon className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-423" />
                <span data-id="element-424">514.659.8161</span>
              </motion.li>
              <motion.li className="flex items-center" whileHover={{
              x: 3
            }} data-id="element-425">
                <MailIcon className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-426" />
                <span data-id="element-427">info@immovendu.com</span>
              </motion.li>
            </ul>
          </motion.div>
        </div>
        <motion.div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-428">
          <p className="text-gray-300" data-id="element-429">
            © 2024 Immovendu. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0" data-id="element-430">
            <ul className="flex space-x-6" data-id="element-431">
              <motion.li whileHover={{
              y: -2
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-432">
                <a href="#" className="text-gray-300 hover:text-[#f2f2ed] text-sm" data-id="element-433">
                  Privacy Policy
                </a>
              </motion.li>
              <motion.li whileHover={{
              y: -2
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-434">
                <a href="#" className="text-gray-300 hover:text-[#f2f2ed] text-sm" data-id="element-435">
                  Terms of Service
                </a>
              </motion.li>
              <motion.li whileHover={{
              y: -2
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-436">
                <a href="#" className="text-gray-300 hover:text-[#f2f2ed] text-sm" data-id="element-437">
                  Cookie Policy
                </a>
              </motion.li>
            </ul>
          </div>
        </motion.div>
      </div>
    </footer>;
};